import gql from 'graphql-tag';

const IMPORT_POLICY_MIGRATION = gql`
  mutation(
    $policySetId: ID!
    $sourcePolicySetId: ID!
    $migrateAllPolicies: Boolean
    $policies: [String]
  ) {
    importPolicySets(
      policySetId: $policySetId
      sourcePolicySetId: $sourcePolicySetId
      migrateAllPolicies: $migrateAllPolicies
      policies: $policies
    )
  }
`;

export { IMPORT_POLICY_MIGRATION };
